import { render, staticRenderFns } from "./veStuAssocLabel.vue?vue&type=template&id=65ab5fa1&scoped=true"
import script from "./veStuAssocLabel.vue?vue&type=script&lang=js"
export * from "./veStuAssocLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ab5fa1",
  null
  
)

export default component.exports